// #/services/workflows/createNode.ts

import { v4 as uuidv4 } from 'uuid';

import { NodeType, TriggerNode, TriggerType } from '#/types/workspace';

export const CronInputSchema = {
  properties: {
    schedule: 'string',
  },
  required: ['schedule'],
  type: 'object',
};

export const CronDefaultInputValues = {
  schedule: '0 12 * * *',
};

export const createTriggerNode = (args: {
  id: string;
  position: { x: number; y: number };
  type?: NodeType;
  data: {
    uuid?: string;
    isLateral?: boolean;
    triggerType: TriggerType;
    logoUrl?: string;
    inputSchema?: Record<string, any>;
    inputValues?: Record<string, any>;
  };
}): TriggerNode => {
  const {
    id,
    position,
    type: nodeType = 'turbo',
    data: {
      uuid = uuidv4(),
      isLateral = false,
      triggerType,
      logoUrl = 'https://alpha.simpfi.ai/simpfinogrid.png',
      inputSchema,
      inputValues,
      // ...restData
    },
    // ...rest
  } = args;
  return {
    // ...rest,
    id,
    position,
    type: nodeType,
    data: {
      // ...restData,
      uuid,
      type: 'trigger',
      logoUrl,
      triggerType,
      title: 'triggers',
      subline: triggerType,
      icons: ['FunctionIcon'],
      isLateral,
      inputSchema:
        inputSchema ?? (triggerType === 'cron' ? CronInputSchema : {}),
      inputValues:
        inputValues ?? (triggerType === 'cron' ? CronDefaultInputValues : {}),
    },
  };
};

export default createTriggerNode;
